"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MenuIcon = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _grey = _interopRequireDefault(require("../tokens/color/grey"));
var _red = _interopRequireDefault(require("../tokens/color/red"));
var _black = _interopRequireDefault(require("../tokens/color/black"));
var _white = _interopRequireDefault(require("../tokens/color/white"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _typography = require("../tokens/typography");
var _misc = _interopRequireDefault(require("../tokens/misc"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable indent */

var Navbar = function Navbar(props) {
  var children = props.children,
    open = props.open,
    navId = props.navId,
    _props$toggleMenuOpen = props.toggleMenuOpen,
    toggleMenuOpen = _props$toggleMenuOpen === void 0 ? null : _props$toggleMenuOpen,
    isTransparent = props.isTransparent;
  var _useState = (0, _react.useState)("100vh"),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    menuHeight = _useState2[0],
    setMenuHeight = _useState2[1];
  var openClosePanel = function openClosePanel() {
    toggleMenuOpen();
  };
  (0, _react.useEffect)(function () {
    var body = document.body;
    var html = document.documentElement;
    var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

    //to cover any error in calculation because of inaccurate layout of page, we add 25% of total height of page
    setMenuHeight(height * 1.25 + "px");
  }, []);
  return /*#__PURE__*/_react["default"].createElement(Navbar.Element, {
    id: navId,
    role: props.isMenuRole ? "menu" : "none",
    "aria-label": "navbar",
    open: open,
    "aria-expanded": open,
    onClick: openClosePanel,
    isTransparent: isTransparent,
    height: menuHeight
  }, _react["default"].Children.map(children, function (child, index) {
    if (!child) return false;
    return child.props.mobileLink && child.props.children ? /*#__PURE__*/_react["default"].createElement(Navbar.item, {
      key: index,
      mobileLink: child.props.mobileLink,
      tabIndex: "0",
      isTransparent: isTransparent,
      open: open
    }, child.props.children) : /*#__PURE__*/_react["default"].createElement(Navbar.item, {
      key: index,
      tabIndex: "0",
      isTransparent: isTransparent,
      open: open,
      active: child.props.active,
      compressed: child.props.isCompressed
    }, /*#__PURE__*/_react["default"].cloneElement(child, {
      isTransparent: isTransparent,
      open: open,
      tabIndex: "-1"
    }));
  }));
};
var MenuIcon = exports.MenuIcon = function MenuIcon(props) {
  return /*#__PURE__*/_react["default"].createElement(MenuIcon.wrapper, props, /*#__PURE__*/_react["default"].createElement(MenuIcon.span, null), /*#__PURE__*/_react["default"].createElement(MenuIcon.span, null), /*#__PURE__*/_react["default"].createElement(MenuIcon.span, null));
};
MenuIcon.wrapper = _styledComponents["default"].div.withConfig({
  componentId: "sc-3o0n99-0"
})(["width:2rem;height:1.5rem;position:relative;transform:rotate(0deg);transition:transform 0.15s ease-in-out;cursor:pointer;opacity:0;pointer-events:none;@media screen and (max-width:768px){&{opacity:1;pointer-events:all;}& > span{background:", ";}", "}"], function (props) {
  return props.isTransparent && !props.open ? _white["default"] : _black["default"];
}, function (props) {
  return props.open && (0, _styledComponents.css)(["& > span:nth-child(1){transform:rotate(45deg);top:-0.1rem;}& > span:nth-child(2){width:0%;opacity:0;}& > span:nth-child(3){transform:rotate(-45deg);top:1.3rem;}"]);
});
MenuIcon.span = _styledComponents["default"].span.withConfig({
  componentId: "sc-3o0n99-1"
})(["transform-origin:left center;display:block;position:absolute;cursor:pointer;height:3px;width:100%;border-radius:0;opacity:1;left:0;transform:rotate(0deg);transition:transform 0.15s ease-in-out,all 0.15s linear;&:nth-child(1){top:0;}&:nth-child(2){top:0.6rem;}&:nth-child(3){top:1.2rem;}"]);
var getActiveStyles = function getActiveStyles(_ref) {
  var _ref$isTransparent = _ref.isTransparent,
    isTransparent = _ref$isTransparent === void 0 ? false : _ref$isTransparent,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active;
  if (!active) {
    return (0, _styledComponents.css)([""]);
  }
  var styles = isTransparent && active ? (0, _styledComponents.css)(["color:", ";font-weight:", ";border-bottom-color:", ";"], _white["default"], _typography.fontWeights.medium, _white["default"]) : (0, _styledComponents.css)(["color:", ";border-bottom-color:", ";"], _black["default"], _red["default"].z500);
  return styles;
};
Navbar.Wrapper = _styledComponents["default"].div.withConfig({
  componentId: "sc-3o0n99-2"
})(["display:flex;align-items:center;flex-grow:1;justify-content:flex-end;@media screen and (max-width:768px){&{position:absolute;width:100%;height:100%;left:0;}}"]);
Navbar.Element = _styledComponents["default"].ul.withConfig({
  componentId: "sc-3o0n99-3"
})(["width:100%;list-style:none;max-width:100%;height:72px;padding-top:1.5rem;padding-bottom:1.7rem;display:flex;flex-wrap:nowrap;background:transparent;align-items:center;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:flex-end;user-select:none;opacity:1;transition-delay:0s;padding:1.7rem 0;margin:0;transition:opacity 0.25s linear,visibility 0.25s linear,height 0.25s cubic-bezier(0.52,0.16,0.24,1);> *{margin-right:2rem;}> *:last-child{margin-right:0;}@media screen and (max-width:768px){&{height:0;visibility:hidden;flex-direction:column;position:absolute;width:100%;align-items:flex-start;justify-content:flex-start;background:", ";top:99%;left:0;margin:0;padding:0;transition:height 0.25s cubic-bezier(0.52,0.16,0.24,1);", "}> *{margin-right:0;}}"], _white["default"], function (props) {
  return props.open && (0, _styledComponents.css)(["padding:10px 22px;visibility:visible;height:", ";transition:height 0.25s cubic-bezier(0.52,0.16,0.24,1);"], props.height);
});
Navbar.item = _styledComponents["default"].li.withConfig({
  componentId: "sc-3o0n99-4"
})(["> *{margin-right:1.8rem;}> *:last-child{margin-right:0;}&:focus,&:active{outline:none;}padding-bottom:", ";border-radius:0;box-sizing:border-box;border-style:solid;border-color:transparent;border-width:0;border-bottom-width:0.2rem;", " &:not(:-moz-focusring):focus{box-shadow:none;}@media (hover:none){box-shadow:none;outline:none;}@media screen and (max-width:768px){margin-bottom:3.5rem;width:100%;", " ", " &:nth-last-child{margin-bottom:0;}> *{margin-right:0;}}"], function (props) {
  return props.compressed ? 0 : "1rem";
}, function (props) {
  return getActiveStyles(props);
}, function (props) {
  return props.mobileLink && (0, _styledComponents.css)(["flex-direction:column;align-items:center;display:flex;align-self:flex-end;& > *{margin-bottom:2rem;}"]);
}, function (props) {
  return props.open ? (0, _styledComponents.css)(["opacity:1;transition:opacity 0.25s 0.25s linear;"]) : (0, _styledComponents.css)(["opacity:0;transition:opacity 0.25s linear;"]);
});
Navbar.Link = _styledComponents["default"].a.withConfig({
  componentId: "sc-3o0n99-5"
})(["font-size:", ";line-height:", ";text-align:right;vertical-align:middle;font-weight:", ";color:", ";cursor:pointer;padding:0.8rem !important;border-radius:", ";&:hover{color:", ";}&:active,&:hover:active{color:", ";border-bottom-color:", ";outline:none;}&:focus,&:active{outline:none;}", " ", ":focus > &{box-shadow:", ";}@media screen and (max-width:768px){color:", ";border-radius:0;border-width:0;border-color:transparent;&:hover{color:", ";}", "}"], _typography.fontSizes.z400, _typography.lineHeight.medium, _typography.fontWeights.light, function (props) {
  return props.isTransparent ? _white["default"] : _grey["default"].z700;
}, _misc["default"].radius, function (props) {
  return props.isTransparent ? _white["default"] : _black["default"];
}, function (props) {
  return props.isTransparent ? _white["default"] : _black["default"];
}, function (props) {
  return props.isTransparent ? _white["default"] : _red["default"].z500;
}, function (props) {
  return props.active && (0, _styledComponents.css)(["color:", ";border-bottom-color:", ";outline:none;"], function (props) {
    return props.isTransparent ? _white["default"] : _black["default"];
  }, function (props) {
    return props.isTransparent ? _white["default"] : _red["default"].z500;
  });
}, Navbar.item, function (props) {
  return props.isTransparent ? _misc["default"].focusBoxShadow.white : _misc["default"].focusBoxShadow.red;
}, _grey["default"].z700, _black["default"], function (props) {
  return props.active && (0, _styledComponents.css)(["color:", ";border-bottom-style:solid;border-bottom-color:", ";border-bottom-width:2px;"], _black["default"], _red["default"].z500);
});
Navbar.mobileLinks = _styledComponents["default"].aside.withConfig({
  componentId: "sc-3o0n99-6"
})(["display:flex;@media screen and (max-width:768px){&{flex-direction:column;align-self:flex-end;}}"]);
Navbar.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  navId: _propTypes["default"].string,
  open: _propTypes["default"].bool,
  toggleMenuOpen: _propTypes["default"].func,
  bgColor: _propTypes["default"].string,
  isTransparent: _propTypes["default"].bool,
  isMenuRole: _propTypes["default"].bool
};
var _default = exports["default"] = Navbar;